import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DwMenuService, DwMenuServiceState, DwSecurityUserService, DwAuthenticationType, DwComponent, DwComponentType } from '@devwareapps/devware-cap';
import { AviatorUser } from '../../../shared/models/aviator-user.model';
import { AdminManagerService } from '../../../admin/services/admin-manager.service';
import { FlightSchoolSettingsConfigComponent } from './config/flight-school-settings-config/flight-school-settings-config.component';
import { FlightSchoolSettingsConfig } from '../../models/flight-school-settings-config.model';


@DwComponent({
  key: 'flight-school-settings',
  name: 'Flight School Settings',
  componentType: DwComponentType.pageComponent,
  configComponent: FlightSchoolSettingsConfigComponent,
})
@Component({
  selector: 'app-flight-school-settings',
  templateUrl: './flight-school-settings.component.html',
  styleUrls: ['./flight-school-settings.component.scss']
})
export class FlightSchoolSettingsComponent implements OnInit, OnDestroy {
  keyValue: number;
  subscriptions: Subscription[] = [];
  configKeyPart: string = 'profile';
  aviatorUser: AviatorUser;

  flightSchoolSettingsConfig: FlightSchoolSettingsConfig;

  constructor(
    private dwSecurityUserService: DwSecurityUserService,
    private adminManagerService: AdminManagerService,
     private dwMenuService: DwMenuService,
  ) {

  }

  ngOnInit() {
    this.subscriptions.push(
      this.dwSecurityUserService.securityContextChanged().subscribe(securityContext => {
        if (securityContext) {
          this.aviatorUser = this.adminManagerService.getAviatorUser(securityContext?.ApplicationUser);

          this.keyValue = this.aviatorUser?.FlightSchoolId;
        }
      })
    );

    this.flightSchoolSettingsConfig = this.dwMenuService.menuState.currentMenu?.data?.componentConfig as FlightSchoolSettingsConfig;

    this.configKeyPart = this.flightSchoolSettingsConfig?.configKeyPart || 'profile';
  }

  ngOnDestroy(): void {
    for (let subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

}